/* ===================================================================
   NALANDA ENTERPRISES — Premium JS v2.0
   =================================================================== */

(function () {
  'use strict';

  /* ---------- 1. Scroll Reveal ---------- */
  function initReveal() {
    const els = document.querySelectorAll('.np-reveal, .np-reveal-left, .np-reveal-right, .np-reveal-scale');
    if (!els.length) return;
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2. Animated Counter ---------- */
  function animateCounter(el, target, duration) {
    var start = 0;
    var startTime = null;
    var suffix = el.dataset.suffix || '';
    var prefix = el.dataset.prefix || '';
    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.floor(eased * target);
      el.textContent = prefix + current.toLocaleString('en-IN') + suffix;
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = prefix + target.toLocaleString('en-IN') + suffix;
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    var counters = document.querySelectorAll('.np-counter');
    if (!counters.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var target = parseInt(e.target.dataset.target, 10);
          animateCounter(e.target, target, 2000);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.3 });
    counters.forEach(function (c) { io.observe(c); });
  }

  /* ---------- 3. Testimonials Slider ---------- */
  function initTestimonialSlider() {
    var slider = document.querySelector('.np-testimonials__viewport');
    if (!slider) return;
    var track = slider.querySelector('.np-testimonials__track');
    var slides = Array.from(track.querySelectorAll('.np-testimonial'));
    if (slides.length < 2) return;
    var btnPrev = document.querySelector('.np-tslider-prev');
    var btnNext = document.querySelector('.np-tslider-next');
    var dotsWrap = document.querySelector('.np-tdots');
    var current = 0;
    var perView = window.innerWidth < 750 ? 1 : window.innerWidth < 990 ? 2 : 3;
    var total = Math.ceil(slides.length / perView);

    // Build dots
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.className = 'np-tdot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.dataset.idx = i;
        dotsWrap.appendChild(dot);
      }
      dotsWrap.addEventListener('click', function (e) {
        var dot = e.target.closest('.np-tdot');
        if (dot) goTo(parseInt(dot.dataset.idx, 10));
      });
    }

    function updateDots() {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('.np-tdot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    function goTo(idx) {
      current = Math.max(0, Math.min(idx, total - 1));
      var slideWidth = slides[0].getBoundingClientRect().width;
      var gap = 24;
      track.style.transform = 'translateX(-' + (current * perView * (slideWidth + gap)) + 'px)';
      updateDots();
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { goTo(current - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { goTo(current + 1); });

    // Auto-play
    var autoplay = setInterval(function () {
      goTo(current + 1 >= total ? 0 : current + 1);
    }, 5000);
    slider.addEventListener('mouseenter', function () { clearInterval(autoplay); });

    // Touch swipe
    var startX = 0;
    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) goTo(diff > 0 ? current + 1 : current - 1);
    });

    window.addEventListener('resize', function () {
      perView = window.innerWidth < 750 ? 1 : window.innerWidth < 990 ? 2 : 3;
      total = Math.ceil(slides.length / perView);
      goTo(0);
    });
  }

  /* ---------- 4. FAQ Accordion ---------- */
  function initFaq() {
    var items = document.querySelectorAll('.np-faq-item');
    items.forEach(function (item) {
      var btn = item.querySelector('.np-faq-btn');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (i) { i.classList.remove('is-open'); });
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  /* ---------- 5. Sticky Header ---------- */
  function initStickyHeader() {
    var lastY = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      document.body.classList.toggle('np-scrolled', y > 60);
      lastY = y;
    }, { passive: true });
  }

  /* ---------- 6. Back to Top ---------- */
  function initBackTop() {
    var btn = document.querySelector('.np-back-top');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('is-visible', window.scrollY > 400);
    }, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---------- 7. Announcement Close ---------- */
  function initAnnouncementClose() {
    var closeBtn = document.querySelector('.np-announcement__close');
    var bar = document.querySelector('.np-announcement');
    if (closeBtn && bar) {
      closeBtn.addEventListener('click', function () {
        bar.style.maxHeight = bar.offsetHeight + 'px';
        requestAnimationFrame(function () {
          bar.style.transition = 'max-height 0.35s ease, opacity 0.35s ease';
          bar.style.maxHeight = '0';
          bar.style.opacity = '0';
        });
        setTimeout(function () { bar.style.display = 'none'; }, 400);
      });
    }
  }

  /* ---------- 8. Lazy image quality fix ---------- */
  function initLazyImages() {
    var images = document.querySelectorAll('img[loading="lazy"]');
    images.forEach(function (img) {
      if (img.complete) {
        img.classList.add('np-img-loaded');
      } else {
        img.addEventListener('load', function () {
          img.classList.add('np-img-loaded');
        });
      }
    });
  }

  /* ---------- 9. Card hover 3D tilt ---------- */
  function initCardTilt() {
    document.querySelectorAll('.np-corp-card').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        card.style.transform = 'translateY(-5px) perspective(600px) rotateX(' + (-y / 20) + 'deg) rotateY(' + (x / 20) + 'deg)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  /* ---------- 10. Init all ---------- */
  function init() {
    initReveal();
    initCounters();
    initTestimonialSlider();
    initFaq();
    initStickyHeader();
    initBackTop();
    initAnnouncementClose();
    initLazyImages();
    initCardTilt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
